import {
  Home,
  Car,
  Scissors,
  Dumbbell,
  PawPrint,
  Smile,
  Bone,
  Brain,
  Eye,
  Activity,
  Banknote,
  ShieldCheck,
  FileText,
  BarChart3,
  BadgeDollarSign,
  LockKeyhole,
  GraduationCap,
  School,
  Briefcase,
  Laptop,
  FileCheck,
  Plane,
  Bed,
  Ship,
  Leaf,
  Sprout,
  PlaneTakeoff,
  Droplets,
  Truck,
  Settings,
  HeartPulse,
} from "lucide-react";

export type Industry = {
  title: string;
  slug: string;
  description: string;
  icon: any;
  image: string;
  subIndustries: {
    title: string;
    description: string;
    icon: any;
    img: string;
  }[];
};

export const industries: Industry[] = [
  {
    title: "Local Services",
    slug: "local-services",
    description: "AI agents automate customer interactions, schedule appointments, and manage local queries to improve service efficiency.",
    icon: Home,
    image: "/homeServices.jpg",
    subIndustries: [
      {
        title: "Home Services",
        description: "Scheduling, quotes, and dispatch.",
        icon: Home,
        img: "/Ai in library.jpeg",
      },
      {
        title: "Beauty & Personal Care",
        description: "Bookings and service menus.",
        icon: Scissors,
        img: "/makeupandskincare.jpg",
      },
      {
        title: "Auto Repair",
        description: "Pricing, reminders, and diagnostics.",
        icon: Car,
        img: "/Auto Repair.jpg",
      },
      {
        title: "Fitness & Wellness",
        description: "Bookings, billing, and member engagement.",
        icon: Dumbbell,
        img: "/Fitness & Wellness.webp",
      },
      {
        title: "Pet Services",
        description: "FAQs, reminders, and appointment scheduling.",
        icon: PawPrint,
        img: "/Pet Services.jpg",
      },
    ],
  },
  {
    title: "Medical",
    slug: "medical",
    description:
      "AI agents streamline diagnostics, appointment scheduling, and patient follow-ups for faster, more accurate care.",
    icon: HeartPulse,
    image: "/medical.jpg",
    subIndustries: [
      {
        title: "Dental Practices",
        description: "Scheduling, insurance data, and reminders.",
        icon: Smile,
        img: "/DentalPractices.jpg",
      },
      {
        title: "Chiropractic Clinics",
        description: "Reminders and patient education.",
        icon: Bone,
        img: "/chiropractor 2.jpg",
      },
      {
        title: "Mental Health Practices",
        description: "HIPAA-compliant chatbots and billing.",
        icon: Brain,
        img: "/Mental Health Practices.jpg",
      },
      {
        title: "Optometry",
        description: "Product details and bookings.",
        icon: Eye,
        img: "/opto.jpg",
      },
      {
        title: "Physical Therapy",
        description: "Patient engagement and exercise reminders.",
        icon: Activity,
        img: "/Physical Therapy.jpg",
      },
    ],
  },
  {
    title: "Finance & Insurance",
    slug: "finance-insurance",
    description:
      "AI agents simplify claims, automate transactions, and provide real-time financial insights for smarter decisions.",
    icon: Banknote,
    image: "/banking.jpg",
    subIndustries: [
      {
        title: "Banking",
        description: "Chatbots, fraud detection, and risk scoring.",
        icon: ShieldCheck,
        img: "/banking.jpg",
      },
      {
        title: "Insurance",
        description: "Claims automation, underwriting, and fraud checks.",
        icon: FileText,
        img: "/Insurance.jpg",
      },
      {
        title: "Investment & Wealth",
        description: "Robo-advisors and portfolio analysis.",
        icon: BarChart3,
        img: "/Investment.jpg",
      },
      {
        title: "Lending & Credit",
        description: "Loan eligibility, credit scoring, and risk analytics.",
        icon: BadgeDollarSign,
        img: "/Lending.jpg",
      },
      {
        title: "RegTech",
        description: "Compliance automation and audit trails.",
        icon: LockKeyhole,
        img: "/RegTech.jpg",
      },
    ],
  },
  {
    title: "Education & Training",
    slug: "education-training",
    description:
      "AI agents personalize learning paths, automate assessments, and offer on-demand tutoring to enhance engagement",
    icon: GraduationCap,
    image: "/EducationTraining.jpg",
    subIndustries: [
      {
        title: "K-12 & Higher Ed",
        description: "AI tutors, grading, and student engagement.",
        icon: School,
        img: "/K-12 & Higher Ed.jpg",
      },
      {
        title: "Corporate Training",
        description: "Learning paths and knowledge tracking.",
        icon: Briefcase,
        img: "/Regtechnology.jpg",
      },
      {
        title: "Online Learning",
        description: "Adaptive content and learner analytics.",
        icon: Laptop,
        img: "/onlinelearningedu.jpg",
      },
      {
        title: "Language Learning",
        description: "AI conversation partners and progress tracking.",
        icon: FileCheck,
        img: "/EducationTraining.jpg",
      },
      {
        title: "Testing & Certification",
        description: "Auto-assessment and proctoring.",
        icon: FileCheck,
        img: "/AutomatioWorkflow.jpg",
      },
    ],
  },
  {
    title: "Hospitality & Travel",
    slug: "hospitality-travel",
    description:
      "AI agents handle bookings, answer guest queries, and personalize itineraries for seamless customer experiences.",
    icon: Plane,
    image: "/HospitalityTravel.jpg",
    subIndustries: [
      {
        title: "Hotels & Resorts",
        description: "Virtual concierge and dynamic pricing.",
        icon: Bed,
        img: "/HotelsResorts.jpg",
      },
      {
        title: "Airlines",
        description: "Route optimization and chatbot support.",
        icon: PlaneTakeoff,
        img: "/Airlines.jpg",
      },
      {
        title: "Travel Agencies",
        description: "Trip planning and customer service.",
        icon: Plane,
        img: "/TravelAgencies.jpg",
      },
      {
        title: "Vacation Rentals",
        description: "Guest messaging and automated cleaning schedules.",
        icon: Home,
        img: "/HospitalityTravel.jpg",
      },
      {
        title: "Cruise & Tour Ops",
        description: "Capacity planning and personalized itineraries.",
        icon: Ship,
        img: "/Cruise & Tour Ops.jpg",
      },
    ],
  },
  {
    title: "Agriculture & AgTech",
    slug: "agriculture-agtech",
    description:
      "AI agents optimize crop management, monitor environmental data, and forecast yields to boost productivity.",
    icon: Leaf,
    image: "/SmartIrrigation.jpg",
    subIndustries: [
      {
        title: "Crop Monitoring",
        description: "AI for pest detection and yield prediction.",
        icon: Sprout,
        img: "/CropMonitoring.jpg",
      },
      {
        title: "Farming",
        description: "AI for farming and agriculture.",
        icon: Leaf,
        img: "/futureFarming.jpg",
      },
      {
        title: "Smart Irrigation",
        description: "Sensor-based watering with weather predictions.",
        icon: Droplets,
        img: "/SmartIrrigation.jpg",
      },
      {
        title: "Agri Supply Chain",
        description: "Logistics and demand forecasting.",
        icon: Truck,
        img: "/AgriSupplyChain.jpg",
      },
      {
        title: "Farm Automation",
        description: "Autonomous machinery and drone analytics.",
        icon: Settings,
        img: "/FarmAutomation.jpg",
      },
    ],
  },
]; 

export const caseStudies = [
  {
    industry: "Home Services",
    company: "Pristine Cleaners",
    challenge: "Was overwhelmed with booking calls and quote requests, often missing leads outside of business hours.",
    solution: "We deployed an AI chatbot on their website to provide instant quotes and book cleaning appointments 24/7.",
    result: "Achieved a 30% increase in online bookings and saved 10+ administrative hours per week."
  },
  {
    industry: "Medical",
    company: "Dr. Smith's Dental Clinic",
    challenge: "Dealing with high patient volume and limited staff during peak hours.",
    solution: "We implemented an AI-powered chatbot that handles routine inquiries, schedules appointments, and provides pre-visit information.",
    result: "Reduced wait times by 50% and increased patient satisfaction by 30%."
  },
  {
    industry: "Finance & Insurance",
    company: "FinCorp Bank",
    challenge: "Managing high volumes of loan applications and fraud detection.",
    solution: "We integrated an AI-driven fraud detection system that analyzed transaction patterns and flagged suspicious activities in real-time.",
    result: "Reduced fraudulent transactions by 40% and improved risk management."
  },
  { 
    industry: "Education & Training",
    company: "TechEd Institute",
    challenge: "Scaling online learning platforms while maintaining personalized student support.",
    solution: "We developed an AI-powered chatbot that handles routine inquiries, schedules appointments, and provides pre-visit information.",
    result: "Reduced wait times by 50% and increased patient satisfaction by 30%."
  },
  {
    industry: "Hospitality & Travel",
    company: "Luxury Hotels",
    challenge: "Managing high volumes of guest inquiries and reservations.",
    solution: "We implemented an AI-powered chatbot that handles routine inquiries, schedules appointments, and provides pre-visit information.",
    result: "Reduced wait times by 50% and increased patient satisfaction by 30%."
  },
  {
    industry: "Agriculture & AgTech",
    company: "GreenGro Farms",
    challenge: "Managing high volumes of guest inquiries and reservations.",
    solution: "We implemented an AI-powered chatbot that handles routine inquiries, schedules appointments, and provides pre-visit information.",
    result: "Reduced wait times by 50% and increased patient satisfaction by 30%."
  }
];